import './style/toolbar.css';
import React, { useCallback } from 'react';
import { useEditorState, useEditorView } from './EditorProvider';
var ToolbarButton = function (_a) {
    var item = _a.item;
    var state = useEditorState();
    var view = useEditorView();
    var executeAction = useCallback(function (event) {
        event.preventDefault();
        // eslint-disable-next-line @typescript-eslint/unbound-method
        item.action(state, view.dispatch, view);
    }, [item, state, view]);
    return (React.createElement("button", { type: "button", className: "prosemirror-toolbar-item", "data-active": item.active && item.active(state), disabled: item.enable && !item.enable(state), onMouseDown: executeAction, title: item.title }, item.content));
};
var ToolbarGroup = function (_a) {
    var items = _a.items;
    return (React.createElement("div", { className: "prosemirror-toolbar-group" }, items.map(function (item) { return (React.createElement(ToolbarButton, { key: item.id, item: item })); })));
};
export var Toolbar = React.memo(function (_a) {
    var toolbar = _a.toolbar, _b = _a.className, className = _b === void 0 ? '' : _b;
    return (React.createElement("div", { className: "prosemirror-toolbar " + className }, toolbar.map(function (group) { return (React.createElement(ToolbarGroup, { key: group.id, items: group.items })); })));
});
Toolbar.displayName = 'Toolbar';
